module.exports = __webpack_public_path__ + "img/JC.6bc49f76.png";